import RadioGroupField from "components/controls/RadioGroupField";
import { useField } from "formik";
import React from "react";
import { VSpace } from "../Spacer";
import { RadioGroupFieldConfig } from "./types";
import { useDynamicConfig } from "./useDynamicConfig";

type Props = { fieldConfig: RadioGroupFieldConfig };

// Yes / No / Not defined option buttons bound to a nullable boolean form value
export const RadioGroupFormField = ({ fieldConfig }: Props) => {
  const config = {
    ...fieldConfig,
    ...useDynamicConfig(fieldConfig.d),
  };
  const { name, label, isVisible = true, isDisabled, isRequired } = config;
  const [field, { error }, { setValue }] = useField(name);

  if (!isVisible) return null;

  // own block: RadioGroupField is 100% high, which inside a stretched dialog column would take the whole column
  return (
    <div>
      <RadioGroupField
        name={name}
        label={label}
        checked={field.value ?? null}
        setFieldValue={(_, key) =>
          setValue(key === "true" ? true : key === "false" ? false : null)
        }
        errors={error ? { [name]: error } : {}}
        disabled={isDisabled}
        required={isRequired}
      />
      <VSpace height={10} />
    </div>
  );
};
